@if(this.dataService.operation.stories){
    <div class="stories_list">
        @for(story of this.stories; track $index){
            <div class="story_thumbnail" 
                [class.new_story]="!story.viewed"
                (click)="this.openStory(story.ID)"
                >
                <img [src]="story.urlThumbnail" />
            </div>
        }
    </div>
    
    <app-stories-player #storiesPlayer />
}